
import {
    CLEAR,
    CHANGE_VIEW,
    INIT_PROJECT,
    SET_LAYER_VISIBILITY,
    ADD_COMMAND,
    REMOVE_COMMAND
} from '../sagas/map';

import {
    GET_PROJECT_ACTION_TYPE
} from '../sagas/project';

const initialState = {
    definition: null,
    center: null,
    resolution: null,
    rotation: null,
    zoom: null,
    layers: [],
    groups: [],
    commands: {
        lastUsedId: 0,
        list: []
    }
};

function addCommand(state, name, params) {
    let lastUsedId = state.commands.lastUsedId + 1;
    return {
        lastUsedId: lastUsedId,
        list: [
            ...state.commands.list,
            {
                id: lastUsedId,
                name,
                params
            }
        ]
    };
}

function removeCommand(state, id) {
    return {
        ...state.commands,
        list: state.commands.list.filter(item => {
            return (item.id !== id);
        })
    }
}

function getGroups(mapProject) {
    return mapProject.virtualLayerGroups.map(item => {
        return {
            ...item
        };
    });
}

function getLayers(mapProject) {
    return mapProject.virtualLayers.map(item => {
        return {
            ...item,
            visible: (mapProject.defaultVisibleLayers.indexOf(item.id) !== -1)
        };
    });
}

function setLayerVisibility(layers, id, visible) {
    return layers.map(item => {
        return (item.id === id)
            ? {
                ...item,
                visible: visible
            }
            : {
                ...item
            };
    });
}

export default function map(state = initialState, action) {
    switch (action.type) {

        case CLEAR:
            return {
                ...state
            };

        case CHANGE_VIEW:
            return {
                ...state,
                center: action.center || state.center,
                zoom: action.zoom || state.zoom,
                rotation: action.rotation || state.rotation,
                resolution: action.resolution || state.resolution
            };

        case ADD_COMMAND:
            return {
                ...state,
                commands: addCommand(state, action.name, action.params)
            };

        case REMOVE_COMMAND:
            return {
                ...state,
                commands: removeCommand(state, action.id)
            }

        case INIT_PROJECT:
            return {
                ...state,
                definition: action.mapProject,
                rotation: state.rotation || action.mapProject.rotation || 0,
                layers: (state.layers.length === 0)
                    ? getLayers(action.mapProject)
                    : [...state.layers],
                groups: getGroups(action.mapProject)
            };

        case GET_PROJECT_ACTION_TYPE.DEFAULT:
            return {
                ...initialState
            };

        case SET_LAYER_VISIBILITY:
            return {
                ...state,
               layers: setLayerVisibility(state.layers, action.id, action.visibility)
            };

        default:
            return state
    }
}
